"use strict";

const appHeight = () => {
    document.documentElement.style.setProperty('--appHeight', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);

export function initMultilineEllipsis() {
    $('.clamp, [data-clamp]').each((index, el) => {
        const lines = $(el).attr('data-clamp') || 'auto';
        $clamp(el, {clamp: lines});
    });
}

export function toggleMobileMenu() {
    $(this).toggleClass('is-active');
    $('header nav').toggleClass('active');
    $('body').toggleClass('side-menu-is-open');
}

export function initParallax() {
    if (!$('.jarallax').length) {
        return;
    }

    $('.jarallax').each((index, item) => {
        const $item = $(item);
        const speed = $item.attr('data-speed') || 0.5;
        const type = $item.attr('data-type') || 'scroll';
        const disableMobile= $item.attr('data-disable-mobile') ? /iPad|iPhone|iPod|Android/ : false;
        jarallax($(item), {
            speed,
            type,
            disableParallax: disableMobile,
            disableVideo: disableMobile,
        });
    })
}

export function initSwiper(container) {
    const swipers = new Swiper(container ?? ".swiper:not(.swiper--manual-init)", {
        loop: true,
        loopAdditionalSlides: 1,
        spaceBetween: 2,
        resizeObserver: true,
        updateOnWindowResize: true,
        watchOverflow: true,
        freeModeSticky: true,
        nested: true,
        autoHeight: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            type: 'bullets',
            bulletElement: 'custom',
            bulletActiveClass: 'active',
            bulletClass: 'swiper-navigation',
            renderBullet: function (index, className) {
                return `<button class="swiper-navigation" aria-label="#${++index}"></button> `;
            },
        },
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadOnTransitionStart: true,
        },
        on: {
            init: function(swiper) {
                const totalSlidesCount =  [...swiper.wrapperEl.children].filter(i => !i.classList.contains('swiper-slide-duplicate')).length;
                if (totalSlidesCount === 1) {
                    swiper.disable();
                    // $(swiper.$el).addClass('single-slide');
                }
            },
            slideChange: function(swiper) {
                if (swiper && swiper.autoplay?.running) {
                    const totalSlidesCount = swiper.wrapperEl.childElementCount;
                    const nextSlideIndex = swiper.activeIndex + 1 >= totalSlidesCount ? 0 : swiper.activeIndex + 1;
                    swiper.lazy.loadInSlide(nextSlideIndex);
                }
            },
            touchStart: function(swiper, event) {
                const totalSlidesCount = swiper.wrapperEl.childElementCount;
                const nextSlideIndex = swiper.activeIndex + 1 >= totalSlidesCount ? 0 : swiper.activeIndex + 1;
                const prevSlideIndex = swiper.activeIndex - 1 <= 0 ? totalSlidesCount : swiper.activeIndex - 1;
                swiper.lazy.loadInSlide(prevSlideIndex);
                swiper.lazy.loadInSlide(nextSlideIndex);
                for (let i = 0; i < totalSlidesCount; i++) {
                    if (![prevSlideIndex, swiper.activeIndex, nextSlideIndex].includes(i)) {
                        swiper.lazy.loadInSlide(i);
                    }
                }
            },
            lazyImageReady: (swiper) => {
                swiper.update();
            },
            destroy: (swiper) => {
                $(swiper.$el).find('.swiper-pagination').html('');
            }
        }
    });
    //
    // (Array.isArray(swipers) ? swipers : [swipers]).forEach((swiper) => {
    //     if (!swiper) {
    //         return;
    //     }
    //     if (jQuery(swiper.el).closest('.swiper--play-on-hover')) {
    //         swiper.autoplay.stop();
    //     }
    // });
}

// export function initProductCardCarouselHover() {
//     jQuery('.swiper.swiper--play-on-hover').hover(
//         productCardCarouselHoverIn,
//         productCardCarouselHoverOut
//     );
// }
//
// export function productCardCarouselHoverIn() {
//     const carousel = jQuery(this).get(0);
//     carousel?.swiper?.autoplay?.start();
//     const totalSlidesCount = jQuery(this).find('.swiper-slide').length;
//     const nextSlideIndex = carousel?.swiper.activeIndex + 1 >= totalSlidesCount ? 0 : carousel?.swiper.activeIndex + 1;
//     carousel?.swiper?.lazy.loadInSlide(nextSlideIndex);
// }
//
// export function productCardCarouselHoverOut() {
//     const carousel = jQuery(this).get(0);
//     carousel?.swiper?.autoplay?.stop();
// }

export function initLightbox() {
    const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    })
}

// export function initModalDialogs() {
//     $('.modal .modal__close').on('click', closeModalDialog);
//     $('[data-open-modal]').on('click', openModalDialog);
//     // $(document).on('click', 'body.modal-opened', closeModalDialogOnClickOutside);
// }
// /**
//  *
//  * @param e: Click Event
//  * @param id?: Modal ID to open (other-vice will take from element data attribute)
//  */
// export function openModalDialog(e, id) {
//     e?.preventDefault();
//     const modalId = id || $(this).attr('data-open-modal');
//     const modal = $('#'+modalId);
//     if (modalId && modal.length) {
//         $('body').addClass('modal-opened');
//         modal.addClass('active');
//     }
// }
//
// /**
//  *
//  * @param e: Click Event
//  * @param id?: Modal ID to open (other-vice will take from element data attribute)
//  */
// export function closeModalDialog(e, id) {
//     if (id) {
//         $(`#${id}.modal`).removeClass('active');
//     } else {
//         $(this).closest('.modal').removeClass('active');
//     }
//     if (!$('.modal.active').length) {
//         $('body').removeClass('modal-opened');
//     }
// }
//
// export function closeModalDialogOnClickOutside(e) {
//     if ($(e.target).closest(".modal.active").length === 0) {
//         closeModalDialog();
//     }
// }
//
// export function closeAllModalDialogs() {
//     $('.modal').removeClass('active');
//     $('body').removeClass('modal-opened');
// }


export function getBrowserName() {
    if(navigator.userAgent.indexOf("Opera") !== -1 || navigator.userAgent.indexOf('OPR') !== -1 )
    {
        return 'Opera';
    }
    else if(navigator.userAgent.indexOf("Firefox") !== -1 )
    {
        return 'Firefox';
    }
    else if(navigator.userAgent.indexOf("Edg") !== -1 )
    {
        return 'Edge';
    }
    else if(navigator.userAgent.indexOf("Chrome") !== -1 )
    {
        return 'Chrome';
    }
    else if(navigator.userAgent.indexOf("Safari") !== -1)
    {
        return 'Safari';
    }
    else if((navigator.userAgent.indexOf("MSIE") !== -1 ) || (!!document.documentMode == true )) //IF IE > 10
    {
        return 'IE';
    }
    else
    {
        return 'unknown';
    }
}

export function appendBrowserSpecificClassName() {
    $('body').addClass(`browser-${getBrowserName().toLowerCase()}`);
}

export default function init(){
    appHeight();
    initMultilineEllipsis();
    initParallax();
    initSwiper();
    // initProductCardCarouselHover();
    initLightbox();
    appendBrowserSpecificClassName();
    // initModalDialogs();
    $('header .hamburger').on('click', toggleMobileMenu);
}
